import { Grid, TextField } from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import MeditocModal from "../../../utils/MeditocModal";
import { useEspecialidad } from "../../../../context/EspecialidadContext";

export default function FormEspecialidad() {
  const {
    especialidadSeleccionada,
    modalOpenFormEspecialidad,
    formEspecialidad,
    handleOpenFormEspecialidad,
    handleChangeFormEspecialidad,
    handleSubmitFormEspecialidad,
  } = useEspecialidad();

  const { txtNombreEspecialidad } = formEspecialidad;
  return (
    <MeditocModal
      title={
        especialidadSeleccionada.iIdEspecialidad === 0
          ? "Nueva especialidad"
          : "Editar especialidad"
      }
      okfunc={handleSubmitFormEspecialidad}
      setopen={handleOpenFormEspecialidad}
      open={modalOpenFormEspecialidad}
      okmessage="Guardar"
      size="small"
      form
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            name="txtNombreEspecialidad"
            label={txtNombreEspecialidad.label}
            required={txtNombreEspecialidad.required}
            value={txtNombreEspecialidad.value}
            error={txtNombreEspecialidad.error}
            helperText={
              txtNombreEspecialidad.error && txtNombreEspecialidad.message
            }
            onChange={handleChangeFormEspecialidad}
            variant={inputVariant}
            color={inputColor}
            fullWidth
            autoFocus
          />
        </Grid>
      </Grid>
    </MeditocModal>
  );
}
